import { DataTable } from '@/components/table/DataTable';
import { Text } from '@/components/ui/text';
import { useLiteratureReviewsService } from '@/services/literatureReviews';
import { getPaginationRowModel } from '@tanstack/react-table';
import { useState } from 'react';
import { useLiteratureReviewsColumns } from './columns';

export const LiteratureReviewsTable = () => {
  const columns = useLiteratureReviewsColumns();
  const { literatureReviews, isPending, error } = useLiteratureReviewsService();

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  if (error) {
    return (
      <Text variant="body-sm" color="primary">
        An error occurred
      </Text>
    );
  }

  return (
    <DataTable
      columns={columns}
      data={literatureReviews || []}
      isLoading={isPending}
      options={{
        getPaginationRowModel: getPaginationRowModel(),
        onPaginationChange: setPagination,
        getRowId: row => row.id,
        autoResetPageIndex: false,
        state: {
          pagination,
        },
      }}
    />
  );
};
